<template>
    <el-dialog title="邀请记录" :visible.sync="showModal" width="80%" :close-on-click-modal="false"
        :destroy-on-close="true">
        <div class="filter-container">
            <div class="filter-item">
                <el-input v-model="listQuery.user_account_name" size="medium" placeholder="用户名" />
            </div>
            <div class="filter-item">
                <el-date-picker v-model="filteDateRange" size="medium" type="daterange" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm" clearable
                    @change="onChangeDateRange" />
            </div>
            <div class="filter-item">
                <el-button type="primary" size="medium" @click="handleSearch">搜索</el-button>
            </div>
        </div>

        <div class="table">
            <el-table v-loading="tableLoading" :data="tableData" element-loading-text="Loading" size="small" border fit>
                <el-table-column type="index" align="center" label="序号" min-width="20" />
                <el-table-column label="头像" min-width="30" align="center">
                    <template slot-scope="scope">
                        <el-image style="width: 50px; height: 50px" :src="scope.row.ionvitation_info.head_img"
                            fit="cover"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="ionvitation_info.name" label="昵称" min-width="38" align="center" />
                <el-table-column prop="ionvitation_info.account" label="联系电话" min-width="50" align="center" />
                <el-table-column label="性别" min-width="20" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.ionvitation_info.gender === 1">男</span>
                        <span v-else-if="scope.row.ionvitation_info.gender === 2">女</span>
                        <span v-else>未设置</span>
                    </template>
                </el-table-column>
                <el-table-column prop="get_integral" label="积分" min-width="50" align="center" />
                <el-table-column prop="created_at" label="注册时间" min-width="50" align="center" />
            </el-table>

            <div class="pagination-container">
                <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50, 100]"
                    :page-size="listQuery.limit" :total="total" background
                    layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" />
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { user } from "@/api/userManagement"

export default {
    data: () => ({
        tableLoading: false,
        tableData: [],
        listQuery: {
            page: 1,
            limit: 10,
            time_1: null,
            time_2: null,
            user_account_name: ''
        },
        total: 0,
        filteDateRange: null
    }),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        // 用户ID
        userID: null | String
    },
    methods: {
        trunOff() {
            this.showModal = false
        },
        async getList() {
            this.tableLoading = true
            const { data } = await user.invitationRecord({ user_id: this.userID, ...this.listQuery })
            this.tableData = data.data.filter(item=>item.ionvitation_info !== null)
            this.total = data.total
            this.tableLoading = false
        },
        handleSizeChange(limit) {
            this.listQuery.limit = limit
            this.getList()
        },
        handleCurrentChange(page) {
            this.listQuery.page = page
            this.getList()
        },
        onChangeDateRange(t) {
            if (t === null) {
                this.listQuery.time_1 = null
                this.listQuery.time_2 = null
            }
            this.listQuery.time_1 = t[0]
            this.listQuery.time_2 = t[1]
        },
        handleSearch() {
            this.listQuery.page = 1
            this.getList()
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
    },
    created() {
        this.getList()
    }
}
</script>

<style lang="scss" scoped>

</style>